import React from "react";
import { Link, useLocation } from "react-router-dom";
import { globalStore } from "stores/globalStore";
import { showErrorToast } from "utils/toastNotification";

const AddressDelivery = () => {
  const location = useLocation(); // Access the location object to get state data
  const { addressPageData } = globalStore(); // Access address data from the global store

  const totalCart = location.state?.cartPageData;
  const cartData = totalCart.items;

  const hasAddress = addressPageData && addressPageData.length > 0;
  const itemCount = cartData.length;

  const mrpAmount = cartData.reduce(
    (sum, item) => sum + item.customTShirtPrint.product.price * item.quantity,
    0
  );

  const totalDiscountedPrice = cartData.reduce(
    (sum, item) => sum + item.customTShirtPrint.product.discountPrice * item.quantity,
    0
  );

  const discountAmount = mrpAmount - totalDiscountedPrice;
  const couponDiscount = totalCart?.discountAmountOnCoupon || 0;
  const finalAmount = totalDiscountedPrice - couponDiscount;

  const firstItemImage =
    cartData?.[0]?.customTShirtPrint?.product?.primaryImage || "";

  return (
    <div className="address__delivery-row">
      <div className="address__delivery-column">
        <h3 className="address__delivery-title ui heading size-headingmd">
          DELIVERY ESTIMATES
        </h3>
        <div className="address__delivery-image-row">
          <img
            src={firstItemImage}
            alt="Estimated Delivery Product"
            className="address__delivery-image"
          />
          <p className="address__delivery-date ui text size-text3xl">
            <span>Estimated Deliver by&nbsp;</span>
            <span className="address__delivery-date-span">2 Dec 2024</span>
          </p>
        </div>
        <div className="address__price-column">
          <h4 className="address__delivery-title ui heading size-headingmd">
            PRICE DETAILS ({itemCount} {itemCount === 1 ? "Item" : "Items"})
          </h4>
          <div className="address__price-details">
            <div className="address__price-summary">
              <div className="address__mrp-column">
                <div className="address__mrp-row">
                  <p className="address__total-mrp-text ui text size-text2xl">
                    Total MRP
                  </p>
                  <p className="address__total-mrp-text ui text size-text2xl">
                    ₹{mrpAmount.toFixed(2)}
                  </p>
                </div>
                <div className="address__discount-row-1">
                  <div className="address__discount-mrp-row">
                    <p className="address__total-mrp-text ui text size-text2xl">
                      Discount on MRP
                    </p>
                    <h5 className="address__know-more ui heading size-headings">
                      Know More
                    </h5>
                  </div>
                  <p className="address__discount-value ui text size-text2xl">
                    -₹{discountAmount.toFixed(2)}
                  </p>
                </div>
                <div className="address__coupon-row">
                  <p className="address__coupon-text ui text size-text2xl">
                    Coupon Discount
                  </p>
                  <p className="address__apply-coupon ui text size-text2xl">
                    Apply Coupon
                  </p>
                </div>

                <div className="address__discount-row-1">
                  <div className="address__discount-mrp-row">
                    <p className="address__total-mrp-text ui text size-text2xl">
                      Discount on Coupon
                    </p>
                  </div>
                  <p className="address__discount-value ui text size-text2xl">
                    - ₹{couponDiscount.toFixed(2)}
                  </p>
                </div>

                <div className="address__shipping-row">
                  <div className="address__shipping-column">
                    <div className="address__shipping-fee-row">
                      <p className="address__total-mrp-text ui text size-text2xl">
                        Shipping Fee
                      </p>
                      <h6 className="address__know-more ui heading size-headings">
                        Know More
                      </h6>
                    </div>
                    <p className="address__free-shipping-text ui text size-text2xl">
                      Free shipping for you
                    </p>
                  </div>
                  <div className="product-details__row--prices">
                    <p className="address__old-price-text ui text size-text2xl">
                      ₹80
                    </p>
                    <p className="address__discount-value ui text size-text2xl">
                      FREE
                    </p>
                  </div>
                </div>
              </div>
              <div className="address__total-amount-row">
                <h5 className="address__delivery-title ui heading size-headingmd">
                  Total Amount
                </h5>
                <h5 className="address__delivery-title ui heading size-headingmd">
                  ₹{finalAmount.toFixed(2)}
                </h5>
              </div>
            </div>
            {!hasAddress && (
              <p className="address__no-address-message ui text size-text2xl">
                Please add an address to place your order.
              </p>
            )}
            <Link
              to="/Checkout"
              state={{ cartData, totalCart }}
              className={`flex-row-center-center address__place-order-button ui button deep_orange_700 size-2xl fill round ${
                !hasAddress ? "disabled" : ""
              }`}
              onClick={(e) => !hasAddress && e.preventDefault()} // Prevent navigation if no address
            >
              PLACE ORDER
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressDelivery;